<template>
	<tr style="background-color:white; font-style: italic; color: grey;" :style="{backgroundColor: passedMarketIndex % 2 === 0 ? '#f8f9fa' : '#ffffff'}">
		<td
				v-if="passedSellerIndex === 0 && passedConditionIndex === 0 && passedCommandIndex === 0 && noListings"
				:rowspan="passedTotalRowSpan"
				class="market-cell"
				style="color: black; font-style: normal"
		>
			{{ passedMarketData.market.name}}
			<a @click="openInNewTab(buildLink(passedMarketData.mdsMarketIdentifier))" onmouseover style="cursor: pointer;">
				<img
						:src="`/images/marketicons/${passedMarketData?.marketId}.gif`"
						border="0" width="16" height="16"
						alt=""/>
			</a>
		</td>
		<td :rowspan="passedTotalSellerRowSpan" v-if="passedConditionIndex === 0 && passedCommandIndex === 0 && noListings" class="vert-align" style="color: black; font-style: normal">{{ passedSeller }}</td>
		<td class="vert-align">{{ command.quantity }}</td>
		<td class="vert-align">{{ getConditionName(command)}}</td>
		<td class="vert-align">{{ truncateName(command.vendorName) }}</td>
		<!--Seller -->
		<td v-if="command.passedMmData && command.passedMmData.seller">
			<p class="mb-0">
				{{ Number(command.passedMmData.seller).toFixed(2) + ' €' }}
			</p>
		</td >
		<td v-else>-</td>
		<!--buyBoxPrice -->
		<td>-</td>
		<!--FBA -->
		<td>-</td>
		<!--minimumPrice -->
		<td v-if="command.minimumPrice">
			<span class="mb-0">{{ formatePrice(command.minimumPrice, passedMarketData.country.currencyIso, command.shippingCost) }}</span>
			<span v-if="passedMarketData.country.currencyIso !== 'EUR'">
				<br> {{ convertPriceToEuro(command.minimumPrice, passedMarketData.country.currencyToEuro, command.shippingCost)}}
			</span>
		</td>
		<td v-else>-</td>
		<!--sellingPrice -->
		<td v-if="command.sellingPrice">
			<span class="mb-0">{{ formatePrice(command.sellingPrice, passedMarketData.country.currencyIso, command.shippingCost) }}</span>
			<span v-if="passedMarketData.country.currencyIso !== 'EUR'">
				<br> {{ convertPriceToEuro(command.sellingPrice, passedMarketData.country.currencyToEuro, command.shippingCost)}}
			</span>
		</td>
		<td v-else>-</td>
		<!--maximumPrice -->
		<td v-if="command.maximumPrice">
			<span class="mb-0">{{ formatePrice(command.maximumPrice, passedMarketData.country.currencyIso, command.shippingCost) }}</span>
			<span v-if="passedMarketData.country.currencyIso !== 'EUR'">
				<br> {{ convertPriceToEuro(command.maximumPrice, passedMarketData.country.currencyToEuro, command.shippingCost)}}
			</span>
		</td>
		<td v-else>-</td>
		<!--status -->
		<td class="vert-align">
			{{ formatCommandType(command)}}
			<b-btn size="sm" class="ml-2" title="show timestamps" @click="showTimestampsModal = true"  ><i class="bi bi-info-circle-fill"></i></b-btn>
			<b-modal
					v-model="showTimestampsModal"
					title="Listing Timestamps"
					size="sm"
					hide-footer
					hide-header
			>
				Erstellt:       {{ moment(command.createdAt).format('DD.MM.YYYY HH:mm:ss') }} <br>
				letztes Update: {{ moment(command.updatedAt).format('DD.MM.YYYY HH:mm:ss') }}
			</b-modal>
		</td>
	</tr>
</template>

<script>

export default {
	components: {},
	props: {
		passedCommand: {
			type: Object,
		},
		passedSeller: {
			type: String,
			required: true,
		},
		passedSellerIndex: {
			type: Number,
			required: true,
		},
		passedCondition: {
			type: String,
			required: true,
		},
		passedConditionIndex: {
			type: Number,
			required: true,
		},
		passedCommandIndex: {
			type: Number,
			required: true,
		},
		passedMarketData: {
			type: Object,
			required: true,
		},
		passedMmData: {
			type: Object,
		},
		passedTotalRowSpan: {
			type: Number,
			required: true,
		},
		passedTotalSellerRowSpan: {
			type: Number,
			required: true,
		},
		noListings: {
			type: Number,
			default: 1,
		},
		passedMarketIndex: {
			type: Number,
			required: true,
		},
		passedAsin: {
			type: String,
			required: true,
		},
		passedEan: {
			type: String,
			required: true,
		}
	},
	data() {
		return {
			command: this.passedCommand,
			latestCheckMarket: "",
			currentRowGroupIndex: 0,
			currencySymbols: {
				EUR: '€',   // Euro
				USD: '$',   // US Dollar
				GBP: '£',   // British Pound
				JPY: '¥',   // Japanese Yen
				CAD: 'CAD', // Canadian Dollar
				DKK: 'kr',  // Danish Krone
				PLN: 'zł',  // Polish Zloty
				SEK: 'kr',  // Swedish Krona
				NOK: 'kr',  // Norwegian Krone
				AUD: 'AUD', // Australian Dollar
				MXN: 'MXN', // Mexican Peso
				BRL: 'BRL', // Brazilian Real
				TRY: '₺',   // Turkish Lira
				SGD: 'SGD'  // Singapore Dollar
			},
			marketLinks: {
				"AMZ-AE": "https://www.amazon.ae/",
				"AMZ-AU": "https://www.amazon.com.au/",
				"AMZ-BR": "https://www.amazon.com.br/",
				"AMZ-CA": "https://www.amazon.ca/",
				"AMZ-DE": "https://www.amazon.de/",
				"AMZ-ES": "https://www.amazon.es/",
				"AMZ-FR": "https://www.amazon.fr/",
				"AMZ-IE": "https://www.amazon.ie/",
				"AMZ-IT": "https://www.amazon.it/",
				"AMZ-JP": "https://www.amazon.co.jp/",
				"AMZ-MX": "https://www.amazon.com.mx/",
				"AMZ-NL": "https://www.amazon.nl/",
				"AMZ-BE": "https://www.amazon.com.be/",
				"AMZ-PL": "https://www.amazon.pl/",
				"AMZ-SE": "https://www.amazon.se/",
				"AMZ-SG": "https://www.amazon.sg/",
				"AMZ-TR": "https://www.amazon.com.tr/",
				"AMZ-UK": "https://www.amazon.co.uk/",
				"AMZ-US": "https://www.amazon.com/",
				"BOL-NL": "https://www.bol.com/nl/s/?searchtext=",
				"CDC-FR": "https://www.cdiscount.com/search/10/", //ean.html
				"EPR-IT": "https://www.eprice.it/",
				"FNC-BE": "https://www.fr.fnac.be/SearchResult/ResultList.aspx?Search=", // ean
				"FNC-ES": "https://www.fnac.es/SearchResult/ResultList.aspx?Search=", // ean
				"FNC-FR": "https://www.fnac.com/SearchResult/ResultList.aspx?Search=", // ean
				"FNC-PT": "https://www.fnac.pt/SearchResult/ResultList.aspx?Search=", // ean
				"RAK-FR": "https://fr.shopping.rakuten.com/search/", // ean
				"RDC-FR": "https://www.rueducommerce.fr/",
				"REL-DE": "https://www.kaufland.de/s/?search_value=", //ean
				"WRT-ES": "https://www.worten.es/search?query=", //ean
				"WRT-PT": "https://www.worten.pt/search?query=", //ean
				"ALG-PL": "https://allegro.pl/listing?string=", //ean
				"WAL-US":"https://www.walmart.com/search?q=", // ean
				"KFL-SK": "https://www.kaufland.sk/s/?search_value=", //ean
				"KFL-CZ": "https://www.kaufland.cz/s/?search_value=", //ean
				"KFL-AT": "https://www.kaufland.at/s/?search_value=", //ean
			},
			allSellerIdentifiers: ['MUL', 'COS','WRM', 'LDD'],
			showTimestampsModal: false,
		};
	},
	methods: {
		getConditionName(listing) {
			// console.log(listing.mmData)
			if (listing.condition == 1) {
				return "N";
			} else if (listing.condition == 2 && listing.newAsUsed === false) {
				return "SH";
			} else if (listing.condition == 2 && listing.newAsUsed === true) {
				return "SF";
			}
		},
		formatePrice(price, currencyIso, ownShippingFee = 0) {
			if (price == null || currencyIso == null) return '-';

			const parsedPrice = Number(price);
			let parsedShipping = ownShippingFee == null ? 0 : Number(ownShippingFee);

			if (isNaN(parsedPrice) || isNaN(parsedShipping)) return '-';

			if(this.command.isPrimeSuitable){
				parsedShipping = 0;
			}
			const total = parsedPrice + parsedShipping;
			return total.toFixed(2) + ' ' + (this.currencySymbols[currencyIso] || '');
		},
		convertPriceToEuro(price, conversionRate, ownShippingFee = 0,) {
			if (price == null || conversionRate == null) return '-';
			const parsedPrice = Number(price);
			let parsedShipping = ownShippingFee == null ? 0 : Number(ownShippingFee);

			if (isNaN(parsedPrice) || isNaN(parsedShipping)) return '-';

			if(this.command.isPrimeSuitable){
				parsedShipping = 0;
			}
			const euroTotal = (parsedPrice + parsedShipping) * conversionRate;
			return euroTotal.toFixed(2) + ' €';
		},
		formatCommandType(command){
			const state = command?.state?.substring(0, 1) + '-' ?? '';
			const type = command?.type ?? '';
			const priority = command?.priority ? '-' + command?.priority : '';
			return `${state}${type}${priority}`;
		},
		truncateName(name) {
			return name.length > 15 ? name.substring(0, 15) + '...' : name;
		},
		openInNewTab(url) {
			const win = window.open(url, "_blank");
			win.focus();
		},
		buildLink(marketIdentifier) {
			switch(marketIdentifier.substring(0, 3))
			{
				case "BOL": return this.marketLinks[marketIdentifier] + this.passedEan;
				case "AMZ": return this.marketLinks[marketIdentifier] + 'dp/' + this.passedAsin;
				case "FNC":
				case "WRT":
				case "RAK":
				case "KFL":
				case "REL": return this.marketLinks[marketIdentifier] + this.passedEan;
				case "CDC": return this.marketLinks[marketIdentifier] + this.passedEan + ".html";
				case "ALG": return this.marketLinks[marketIdentifier] + this.passedEan;
				case "WAL": return this.marketLinks[marketIdentifier] + this.passedEan;
				default:    return this.marketLinks[marketIdentifier] + this.passedAsin;
			}
		},
	},
}
</script>
<style scoped>
.market-cell {
	text-align: center;
	vertical-align: middle;
	font-weight: bold;
	border-right: 2px solid #ddd;
}
.vert-align{
	vertical-align: middle
}
</style>